import { useNavigate } from 'react-router-dom';
import { useSession, useContent } from '../hooks/useSession';
import { findLesson, findTrack, lessonKey } from '../lib/curriculum';

/** The 9-step onboarding path — the opinionated order for a brand-new vendor. */
export function PathPage() {
  const content = useContent();
  const { progress } = useSession();
  const navigate = useNavigate();

  return (
    <div className="vu-wrap">
      <div className="vu-kicker">Guided path</div>
      <h1 className="vu-h1">Documents to first promotion, in eight steps</h1>
      <p className="vu-lede" style={{ maxWidth: '64ch' }}>
        Work through these in order. Each step is a real lesson from the library — the path
        just tells you which one matters next. Most vendors finish in a week of evenings.
      </p>

      <div style={{ marginTop: 'var(--space-8)' }}>
        {content.path.map((step) => {
          const done = !!progress.done[lessonKey(step.track, step.lesson)];
          const track = findTrack(content, step.track);
          const lesson = findLesson(track, step.lesson);

          return (
            <button
              key={step.n}
              type="button"
              className="vu-card vu-card-hover"
              style={{
                width: '100%', marginBottom: 'var(--space-3)', cursor: 'pointer',
                padding: 'var(--space-5) var(--space-6)',
              }}
              onClick={() => navigate(`/track/${step.track}/${step.lesson}`)}
            >
              <div className="vu-row" style={{ alignItems: 'flex-start' }}>
                <span
                  className="vu-num"
                  data-done={done}
                  style={done ? undefined : { background: 'var(--orange-50)', color: 'var(--brand-primary)' }}
                >
                  {done ? '✓' : step.n}
                </span>

                <span style={{ flex: 1, minWidth: 0 }}>
                  <span className="vu-h3" style={{ fontSize: 'var(--fs-lg)', display: 'block' }}>
                    {step.title}
                  </span>
                  <span className="vu-muted" style={{ fontSize: 'var(--fs-sm)', display: 'block', margin: '4px 0 8px' }}>
                    {step.body}
                  </span>
                  {track && lesson && (
                    <span className="vu-subtle" style={{ fontSize: 'var(--fs-xs)', fontWeight: 'var(--fw-semibold)' }}>
                      {track.name} · {lesson.mins} min read
                    </span>
                  )}
                </span>

                {/* A pill rather than a tick: at a glance the vendor wants to know what is
                    left to do, not admire what is finished. */}
                <span
                  style={{
                    flex: '0 0 auto',
                    padding: '6px 14px',
                    borderRadius: 'var(--radius-pill)',
                    fontSize: 'var(--fs-xs)',
                    fontWeight: 'var(--fw-semibold)',
                    background: done ? 'var(--success-bg)' : 'var(--surface-sunken)',
                    color: done ? 'var(--green-500)' : 'var(--text-muted)',
                  }}
                >
                  {done ? 'Done' : 'To do'}
                </span>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
